// IMPORTANT: This component is required to disable components during refresh when applying filters or similar
'use client';

import React, { createContext, PropsWithChildren, TransitionStartFunction, useTransition } from 'react';

export type LayoutTemplateProviderProps = PropsWithChildren;

export const LayoutTemplateContext = createContext<{
  startTransition: TransitionStartFunction;
  isPending: boolean;
}>({
  startTransition: (callback) => callback(),
  isPending: false,
});

export default function LayoutTemplateProvider({ children }: LayoutTemplateProviderProps) {
  const [isPending, startTransition] = useTransition();

  return (
    <LayoutTemplateContext.Provider value={{ startTransition, isPending }}>{children}</LayoutTemplateContext.Provider>
  );
}
